// apps/client/src/boot/launchHooks.ts (title screen, 2026-10-05) — `window.__wtLaunch`, DEV and E2E builds only: what the title and the
// screens before a town can't show to a test (window.__wt only exists once a town is entered, game/testHooks.ts). The audio engine's
// state and song, the title step, and the 3D backdrop's status, frames drawn and scene draw calls.
import { pageSound } from '../audio/music';
import type { TitleMotion, TitleStep } from '../state/slices/title';
import { useGame } from '../state/store';
import { backdropInfo, type BackdropInfo } from '../title/backdrop';

export interface LaunchHooks {
  audio(): { context: AudioContextState | 'none'; song: 'title' | 'town' | null; music: number };
  title(): { step: TitleStep; motion: TitleMotion };
  backdrop(): BackdropInfo;
}
declare global { interface Window { __wtLaunch?: LaunchHooks } }

export function installLaunchHooks(): void {
  if (typeof window === 'undefined') return;
  window.__wtLaunch = {
    audio: () => ({ ...pageSound().status(), music: useGame.getState().settings.music }),
    title: () => ({ step: useGame.getState().titleStep, motion: useGame.getState().titleMotion }),
    backdrop: backdropInfo,
  };
}
